import styled from 'styled-components';

export const SquaredButtonStyle = styled.div`
  display: flex;
  width: 280px;
  height: 43px;
  margin-right: 0.5rem;
  font-size: 1.25rem;
  background-color: ${props => props.theme.squaredButtonBgColor};
  color: ${props => props.theme.fieldTextColor};
  cursor: pointer;
  align-items: center;
  justify-content: center;

  &.small {
    width: 230px;
    height: 30px;
    margin-right: 0.25rem;
    font-size: 0.875rem;
  }
  &.blue-bg {
    background-color: ${props => props.theme.recryptLogoBlue};
  }

  &.active,
  &:hover {
    background-color: ${props => props.theme.squaredButtonActiveColor};
    color: ${props => props.theme.squaredButtonColor};
  }

  @media screen and (max-width: 767px) {
    border-bottom: 1px solid ${props => props.theme.bgColor};
    border-radius: 0 5px 0 0;
    max-width: 42.4%;
    justify-content: center;
  }
`;

export const TextWrap = styled.div``;
